import React from 'react';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { CallDispositionActivityService } from 'services/callDispositionActivity';
import { callDispositionActivity as CallDispositionActivityView } from 'ui/views/widgets/callDispositionActivity';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallDispositionActivityWidget } from 'ui/containers/CallDispositionActivityWidget';
 *
 * // render
 * <CallDispositionActivityWidget propName='propValue'/>
 */
export class CallDispositionActivityWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.callDispositionActivityService = new CallDispositionActivityService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'CallDispositionActivityWidget.fetchComponentData()' );

        // cancel ongoing request
        this.callDispositionActivityService.cancel();

        // get status and service data
        const { status, data } = await this.callDispositionActivityService.fetchComponentData( {
            url: this.props.widget.url,
			data: {
				patientId: this.props.patientId				
			}
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.callDispositionActivityService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallDispositionActivityView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...this.state.componentData }
            />
        );
    }
}

// set display name
CallDispositionActivityWidget.displayName = 'CallDispositionActivityWidget';

// set default props
CallDispositionActivityWidget.defaultProps = {};

// prop types
CallDispositionActivityWidget.propTypes = {};
